<template>
  <v-app>

    <Toolbar/>

    <v-main style="background-color: white" class="pa-0">
      <v-fade-transition mode="out-in">
        <router-view :key="routeKey"></router-view>
      </v-fade-transition>
    </v-main>


    <Footer/>

  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Toolbar,
    Footer
  },
  computed: {
    routeKey() {
      const keyBuilder = this.$route.matched[0].meta.keyBuilder;
      return keyBuilder ? keyBuilder(this.$route) : this.$route.path;
    }
  },
  data() {
    return {
      //
    }
  }
}
</script>